import { Trash2, Square, Circle, CornerDownRight } from 'lucide-react';
import { SHAPES, shapeArea, ShapePreview } from './shapes';

const ICONS = { rectangle: Square, lshape: CornerDownRight, circle: Circle };

export function ShapeRow({ section, index, onChange, onRemove, canRemove }) {
  const def = SHAPES[section.type];
  const area = shapeArea(section.type, section.values);

  const setType = (type) => onChange({ ...section, type, values: { ...SHAPES[type].defaults } });
  const setValue = (key, v) => onChange({ ...section, values: { ...section.values, [key]: v } });

  return (
    <div className="rounded-xl border border-[#E9E3D3] bg-white p-4 grid sm:grid-cols-[180px_1fr] gap-4" data-testid={`area-section-${index}`}>
      <div className="rounded-lg bg-[#F7F4EC] p-2 h-36 sm:h-auto sm:aspect-[180/130] shrink-0"><ShapePreview type={section.type} values={section.values} /></div>
      <div className="space-y-3 min-w-0">
        <div className="flex items-center justify-between gap-2">
          <div className="flex gap-1.5 flex-wrap" role="radiogroup">
            {Object.entries(SHAPES).map(([key, s]) => { const Icon = ICONS[key]; return (
              <button key={key} type="button" role="radio" aria-checked={section.type === key} onClick={() => setType(key)} className={`inline-flex items-center gap-1.5 text-xs font-semibold rounded-full px-3 py-1.5 border transition-colors ${section.type === key ? 'bg-[#1B4332] text-white border-[#1B4332]' : 'border-[#E9E3D3] text-[#1B4332] hover:bg-[#F7F4EC]'}`} data-testid={`shape-${key}-${index}`}>
                <Icon className="h-3.5 w-3.5" /> {s.label}
              </button>
            ); })}
          </div>
          {canRemove && <button type="button" onClick={onRemove} className="p-1.5 rounded-full text-red-500 hover:bg-red-50" aria-label="Remove section" data-testid={`remove-section-${index}`}><Trash2 className="h-4 w-4" /></button>}
        </div>
        <div className="grid grid-cols-2 gap-2">
          {def.fields.map((f) => (
            <label key={f.key} className="text-xs text-[#6b6a62]">
              <span className="block mb-1">{f.label}</span>
              <input type="number" min="0" step="0.1" inputMode="decimal" value={section.values[f.key] ?? ''} onChange={(e) => setValue(f.key, e.target.value)} className="w-full rounded-lg border border-[#E9E3D3] px-3 py-2 text-sm text-[#1c1b17] outline-none focus:border-[#40916c] focus:ring-2 focus:ring-[#40916c]/25" data-testid={`field-${f.key}-${index}`} />
            </label>
          ))}
        </div>
        <p className="text-sm">Section area: <span className="font-heading font-bold text-[#1B4332]" data-testid={`section-area-${index}`}>{area ? area.toFixed(1) : '0'} m²</span></p>
      </div>
    </div>
  );
}
